































import { computed, defineComponent, ref, watch } from '@nuxtjs/composition-api';
import { GarageVehicle } from '@shared/composables/useMyGarage/types';
import useVehiclesSidebar from '@shared/composables/useVehiclesSidebar';
import { VehicleSidebarState } from '@shared/system-constants';
import { UCButtonGroup } from '@shared/ui';
import { PartsDbVehicleSummary } from '@unified-commerce/gpc-vue-storefront-parts-db';

import AMXButton from '~/components/AMXButton.vue';
import SearchResults from '~/components/VehiclesSideBar/SearchResults.vue';
import SidebarHeading from '~/components/VehiclesSideBar/SidebarHeading.vue';
import SidebarSubheading from '~/components/VehiclesSideBar/SidebarSubheading.vue';
import useVirtualVehicle from '~/composables/useVirtualVehicle';

import NoResultsFound from '../NoResultsFound.vue';
import VinSearchLookup from './VinSearchLookup.vue';

enum ViewState {
  SEARCH,
  RESULTS,
}

export default defineComponent({
  name: 'VehiclesVINSearch',
  components: {
    UCButtonGroup,
    SidebarSubheading,
    SearchResults,
    AMXButton,
    SidebarHeading,
    NoResultsFound,
    VinSearchLookup,
  },
  // eslint-disable-next-line max-lines-per-function
  setup() {
    const viewState = ref<ViewState>(ViewState.SEARCH);
    const selectedVehicle = ref<GarageVehicle | undefined>();

    const inputYear = ref<number | undefined>(undefined);

    const { setView, close: closeSideBar } = useVehiclesSidebar();

    const vinSearchFormValues = ref({
      vehicles: [] as PartsDbVehicleSummary[],
      exactYear: '',
    });

    const vehicles = computed(() => vinSearchFormValues.value.vehicles);
    const exactYear = computed(() => vinSearchFormValues.value.exactYear);

    const { virtualVehicles, loading, noResults } = useVirtualVehicle({
      vehicles,
      exactYear,
    });

    watch(virtualVehicles, () => {
      if (virtualVehicles.value.length > 0) {
        viewState.value = ViewState.RESULTS;
      }
    });

    const onSearchAgainClicked = () => {
      viewState.value = ViewState.SEARCH;
      inputYear.value = undefined;
    };

    const onRegoSearchClicked = () => setView(VehicleSidebarState.REGO_SEARCH);

    const onManualSearchClicked = () => setView(VehicleSidebarState.MANUAL_SEARCH);

    return {
      viewState,
      ViewState,
      noResults,
      loading,
      selectedVehicle,
      onSearchAgainClicked,
      onRegoSearchClicked,
      onManualSearchClicked,
      inputYear,
      virtualVehicles,
      vinSearchFormValues,
      closeSideBar,
    };
  },
});
